import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { combineLatest, map } from 'rxjs';
import { Logger, PreviewMode, UtilityService } from 'src/app/@shared';
import { AzureAssetsSearchService, SearchAsset } from 'src/app/modules/standard/v1';
import * as dayjs from 'dayjs';
import { ActivatedRoute, Router } from '@angular/router';

const log = new Logger('AssetListCardsComponent');

@Component({
  selector: 'app-asset-list-cards',
  templateUrl: './asset-list-cards.component.html',
  styleUrls: ['./asset-list-cards.component.scss']
})

export class AssetListCardsComponent implements OnInit {
  viewModel$ = combineLatest([
    this.azureAssetsSearchService.assets$,
    this.azureAssetsSearchService.loading$,
    this.azureAssetsSearchService.totalAssetsCount$,
    this.azureAssetsSearchService.searchStateParams$,
  ]).pipe(
    map(([assets, isLoading, totalRecords, searchStateParams]) => {
      this.assetsList = assets;
      assets.forEach(asset => asset.dateAdded = dayjs(asset.dateAdded).format('MM/DD/YYYY'));
      return { assets, isLoading, totalRecords, searchStateParams }
    }),
  );
  assetsList: SearchAsset[] = [];
  selection = new SelectionModel<SearchAsset>(true, []);
  PreviewMode = PreviewMode;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public utilityService: UtilityService,
    private azureAssetsSearchService: AzureAssetsSearchService,
  ) { }

  ngOnInit(): void {
    log.debug('init');
  }

  onPage(pageEvent: PageEvent): void {
    this.selection.clear();
    this.azureAssetsSearchService.pageChange(pageEvent.pageIndex, pageEvent.pageSize);
    this.router.navigate([], { relativeTo: this.route, queryParams: { filter: true }, queryParamsHandling: 'merge' });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.assetsList.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.assetsList.forEach(row => this.selection.select(row));
  }

  public getSelectedSectionRecords() {
    return this.selection.selected;
  }

  public clearSelection() {
    this.selection.clear();
  }

  onImageError(event: Event): void {
    const element = event.target as HTMLImageElement;
    element.src = './assets/images/default-image.png'; // Path to your default image
  }

  onEdit(asset: SearchAsset, index: number) {
    this.azureAssetsSearchService.openAsset(asset, index);
    this.router.navigate([asset.assetId], { relativeTo: this.route, queryParamsHandling: 'preserve' });
  }

}
